 <router-outlet></router-outlet>
 <app-chat-view class="{{code}}-theme" *ngIf="showChat"></app-chat-view>
